import styled from "styled-components";

export const Tel = styled.div`
  font-size: .9rem;
  margin: .2rem 0;
`;